import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import { translate } from 'react-switch-lang';
import appState from '../storages/mobx/appState';

function RightSidebarDrawer({ title, className, children }) {
  const containerClass = classnames({
    'right-sidebar': true,
    show: appState.isRightSidebarOpened,
  });
  return (
    <div className={containerClass} id="right_side_bar">
      {title
      && (
        <div className="container p-0">
          <div className="modal-header p-l-20 p-r-20">
            <div className="col-sm-8 p-0">
              <h6 className="modal-title font-weight-bold">{title}</h6>
            </div>
            <div className="col-sm-4 text-right p-0"><i className="mr-2" data-feather="settings" /></div>
          </div>
        </div>
      )}
      <div className={`${className} mt-0`}>
        <div className="chat-box custom-scrollbar">
          {children}
        </div>
      </div>
    </div>
  );
}

RightSidebarDrawer.defaultProps = {
  title: null,
  className: '',
  children: [],
};
RightSidebarDrawer.propTypes = {
  title: PropTypes.string,
  className: PropTypes.string,
  // eslint-disable-next-line react/forbid-prop-types
  children: PropTypes.any,
};

export default translate(observer(RightSidebarDrawer));
